import { render, staticRenderFns } from "./rbac.vue?vue&type=template&id=21522184&"
import script from "./rbac.vue?vue&type=script&lang=js&"
export * from "./rbac.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports